import { AfterViewChecked, Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user';

@Component({
  selector: 'app-user-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './user-list.component.html',
  //styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit, AfterViewChecked  {
  users: WritableSignal<User[]> = signal([]);

  private userService = inject(UserService);

  ngOnInit() {
    this.userService.getUsers().subscribe({
      next: (users: User[]) => {
        this.users.set(users);
      },
      error: (error: any) => {
        console.error('Failed to fetch users:', error);
      }
    });
  }

  ngAfterViewChecked() {
    console.log('TEMPLATE UPDATED', this);
  }

}
